const getters = {
  getArticleSearchResult: state => state.articleSearch.searchResult,
  getVideoByCategory: state => state.categorySearch.playList,
  getTimeUsing: state => state.momentClose-state.momentOpen
};

export default getters;
